import { render, staticRenderFns } from "./RechargeHistories.vue?vue&type=template&id=1b5d267c&scoped=true&"
import script from "./RechargeHistories.vue?vue&type=script&lang=ts&"
export * from "./RechargeHistories.vue?vue&type=script&lang=ts&"
import style0 from "./RechargeHistories.vue?vue&type=style&index=0&id=1b5d267c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d267c",
  null
  
)

export default component.exports